
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'RenderProps',

  functional: true,

  props: {
    render: {
      type: Function,
      required: true
    },
    props: {}
  },

  render(createElement, ctx) {
    return ctx.props.render(createElement, ctx.props.props)
  }
})
